import $ from 'jquery';

class CardBlock {
    constructor () {
        this.$block = $('.js-card-block');
        this.$button = this.$block.find('.js-show-all');

        if (this.$button.length > 0) {
            this.$button.on('click', $.proxy(this.showAll, this));
        }
    }

    showAll (e) {
        const $elem = $(e.currentTarget);

        e.preventDefault();

        $elem.closest(this.$block).addClass('is-showing-all');
    }
}

export default CardBlock;
